import { INotesSelectComponent } from '@modeso/types__aumico-lib-annualreport-be';
export interface ISelectDelegate {
    selectComponentData(testingProcedureData: INotesSelectComponent, componentIndex: number);
}
